import { render } from "./AppointmentNotifications.vue?vue&type=template&id=62f99ce6"
import script from "./AppointmentNotifications.vue?vue&type=script&lang=js"
export * from "./AppointmentNotifications.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__